import { resolveCDNDir } from '@gjensidige/se-content-helpers';
import { apiFetcher } from '@gjensidige/service-async';

import { WidgetProps } from '../interfaces/Types';

export class AppHelper {
  static CUSTOMER_PHONE_NR_SESSION_KEY = 'customerPhoneNr';
  static phoneNumberErrorText =
    'Ange mobilnumret med 10 siffror och utan bindestreck eller mellanslag.';
  static phoneNrHelpText =
    'Vi ringer gärna upp dig och hjälper dig hitta rätt försäkring för dina behov.';

  static getDefaultData = (): WidgetProps => {
    return {
      headerText: 'Se pris och köp din hemförsäkring',
      tenancyLabel: 'Hyresrätt',
      ownedLabel: 'Bostadsrätt',
      villaRentLabel: 'Hyrd bostadsrätt/villa',
      cprNumberLabel: 'Ditt personnummer',
      cprNumberPlaceHolder: 'ÅÅÅÅMMDDNNNN',
      cprInvalidMessage: 'Vänligen kontrollera personnumret',
      ageBelow18Text: 'Du måste vara över 18 år för att köpa en försäkring',
      addressErrorText: 'Vänligen kontrollera gatuadress',
      zipCodeErrorText: 'Vänligen kontrollera postnumret',
      cprNumberHelpText:
        'Vi behöver ditt personnummer för att kunna ge dig rätt pris. Personnumret ger oss bland annat uppgifter om var du bor och din ålder.',
      zipCodeLabel: 'Postnummer',
      addressLabel: 'Gatuadress',
      calculateBtnLabel: 'Se ditt pris',
      footerMessage: '',
      personalDataHandlingInfoLinkText:
        'Läs mer om vår hantering av dina personuppgifter',
      personalDataHandlinkUrl: '/om-oss/gdpr',
      imageInfo: {
        image: 'KidDogPlaying_simple.jpg',
        smallScreenImage: 'KidDogPlayingSmallScreen_simple.jpg',
        imageAltText: ''
      }
    };
  };

  static getEnonicContent = async (dataUrl: string) => {
    const response: any = await apiFetcher.postJson(dataUrl);
    let enonicData = {};
    if (response.isOk()) {
      if (response.value) {
        enonicData = response.value;
      }
    }
    return enonicData;
  };
  static getImageCDNPath = (fileName: string) =>
    `${resolveCDNDir()}images/${fileName}`;

  static prepareData = (defaultData: WidgetProps, additionalData: any) => {
    return {
      headerText: additionalData?.headerText || defaultData.headerText,
      tenancyLabel: additionalData?.tenancyLabel || defaultData.tenancyLabel,
      ownedLabel: additionalData?.ownedLabel || defaultData.ownedLabel,
      villaRentLabel:
        additionalData?.villaRentLabel || defaultData.villaRentLabel,
      cprNumberLabel:
        additionalData?.cprNumberLabel || defaultData.cprNumberLabel,
      cprNumberPlaceHolder:
        additionalData?.cprNumberPlaceHolder ||
        defaultData.cprNumberPlaceHolder,
      cprNumberHelpText:
        additionalData?.cprNumberHelpText || defaultData.cprNumberHelpText,
      zipCodeLabel: additionalData?.zipCodeLabel || defaultData.zipCodeLabel,
      addressLabel: additionalData?.addressLabel || defaultData.addressLabel,
      calculateBtnLabel:
        additionalData?.calculateBtnLabel || defaultData.calculateBtnLabel,
      cprInvalidMessage:
        additionalData?.cprInvalidMessage || defaultData.cprInvalidMessage,
      ageBelow18Text:
        additionalData?.ageBelow18Text || defaultData.ageBelow18Text,
      addressErrorText:
        additionalData?.addressErrorText || defaultData.addressErrorText,
      zipCodeErrorText:
        additionalData?.zipCodeErrorText || defaultData.zipCodeErrorText,
      footerMessage: additionalData?.footerMessage || defaultData.footerMessage,
      personalDataHandlingInfoLinkText:
        additionalData?.personalDataHandlingInfoLinkText ||
        defaultData.personalDataHandlingInfoLinkText,
      personalDataHandlinkUrl:
        additionalData?.personalDataHandlinkUrl ||
        defaultData.personalDataHandlinkUrl,
      imageInfo: {
        image: additionalData?.imageFileName || defaultData?.imageInfo?.image,
        smallScreenImage:
          additionalData?.smallScreenImageFileName ||
          defaultData?.imageInfo?.smallScreenImage,
        imageAltText: additionalData?.imageAltText || ''
      }
    };
  };
}
